import React from 'react';

import './css/NavBar.css'

let NavBar = props => <nav id="Navbar-container" className="navbar navbar-expand-md bg-light fixed-top">{props.children}</nav>

export default NavBar
